import BlankSlate from "@pathwright/ui/src/components/blank/BlankSlate"
import withTranslate from "@pathwright/ui/src/components/lng/withTranslate"
import LoadingCircle from "@pathwright/ui/src/components/loading/LoadingCircle"
import { useScrollContext } from "@pathwright/ui/src/components/scroll/ScrollView"
import View from "@pathwright/ui/src/components/ui/View"
import PropTypes from "prop-types"
import Masonry from "react-masonry-css"
import styled from "styled-components"
import { useRegistrationListContext } from "./RegistrationListContainer"
import RegistrationListItem from "./RegistrationListItem"

const StyledLoadingWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
`

const StyledView = styled(View)`
  .MasonryGrid {
    display: flex;
    margin-left: -10px; /* gutter size offset */
    width: auto;
  }

  .MasonryGrid__column {
    padding-left: 10px; /* gutter size */
  }

  .MasonryGrid__column > .RegistrationListItem {
    max-width: initial !important;
    margin-bottom: 10px;
  }
`

const RegistrationList = ({ inverted, children, tc }) => {
  const { registrations, loading, hasMore, loadMore, loadingMore } =
    useRegistrationListContext()

  const scrollContext = useScrollContext()
  scrollContext &&
    scrollContext.useScroll({
      onScrollBottom: () => !loadingMore && hasMore && loadMore()
    })

  if (loading) return null

  if (!registrations || !registrations.length) {
    if (children) return children({ inverted })
    return <BlankSlate heading={tc("no results found")} inverted={inverted} />
  }

  return (
    <StyledView paddingTop paddingBottom>
      <Masonry
        breakpointCols={{
          default: 3,
          1700: 3,
          800: 2,
          500: 1
        }}
        className="MasonryGrid"
        columnClassName="MasonryGrid__column"
      >
        {registrations.map((registration) => (
          <RegistrationListItem
            key={registration.id}
            registration={registration}
            inverted={inverted}
          />
        ))}
      </Masonry>
      {loadingMore && (
        <StyledLoadingWrapper>
          <LoadingCircle inverted={inverted} />
        </StyledLoadingWrapper>
      )}
    </StyledView>
  )
}

RegistrationList.displayName = "RegistrationList"

RegistrationList.propTypes = {
  children: PropTypes.func
}

export default withTranslate(RegistrationList)
